import { NgModule } from '@angular/core';
import { LocationTypePipe } from './location-type.pipe';

@NgModule({
    declarations: [LocationTypePipe],
    exports: [LocationTypePipe],
})
export class LocationTypePipeModule {}
